import React from "react";
import { Output } from "../../Text";
import {
  Button,
  ContentSection,
  PageWrap,
  ButtonContainer,
  Paragraph,
} from "@vwfs-bronson/bronson-react";
import Icon, { IconSize } from "../Icon";
import { Analytics } from "../../services/analytics";

const BoniSuccessUCC = ({ onContinue }) => {
  const pageName = "Credit check success";

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
    [Analytics.keys.viewChange()]: pageName,
  };

  const trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: "pageView",
        [Analytics.keys.eventAction(0)]: "Success",
        [Analytics.keys.eventType(1)]: "FinanceApproval",
        [Analytics.keys.eventAction(1)]: "Success",
      };
      Analytics.setTrackingData({ ...defaultTrackingData, ...pageData });
      Analytics.trackPage();
    }, 1000);
  };

  const renderContent = () => {
    return (
      <>
        <Paragraph className="u-mt-large">
          {Output.resolve("pages.boniSuccessUCC.text")}
        </Paragraph>
        <ButtonContainer center className="u-mt-xlarge">
          <Button className="appFixedButton" onClick={onContinue}>
            {Output.resolve("pages.boniSuccessUCC.button")}
          </Button>
        </ButtonContainer>
      </>
    );
  };

  React.useEffect(() => {
    trackPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <ContentSection pale>
        <PageWrap>
          <div className="u-text-center">
            <Icon icon={"semantic-checkmark"} size={IconSize.XxLarge} />
            <h3>{Output.resolveAsMarkdown("pages.boniSuccessUCC.title")}</h3>
          </div>
          {renderContent()}
        </PageWrap>
      </ContentSection>
    </>
  );
};

export default BoniSuccessUCC;
